export function displayInSeconds(milliseconds: number): number {
  return milliseconds / 1000;
}
